'use client';

import { useContext } from 'react';

import { CopilotToolUiContext, type CopilotToolUiContextValue } from './CopilotToolUiContext';

export function useCopilotToolUiOptional(): CopilotToolUiContextValue | null {
  return useContext(CopilotToolUiContext);
}

export function useCopilotToolUi(): CopilotToolUiContextValue {
  const ctx = useCopilotToolUiOptional();
  if (ctx === null) {
    throw new Error('useCopilotToolUi must be used within CopilotToolUiProvider');
  }
  return ctx;
}
